import { PreviewTable } from './components';
import { useTasksTable } from './hooks/useTasksTable.ts';

interface ITasksTableProps {
  groupName?: string;
  footerWidth?: string | number;
  rowOnClick?: (id: string) => void;
  isLoading?: boolean;
}

export const TasksTable = ({
  groupName,
  rowOnClick,
  footerWidth,
  isLoading,
}: ITasksTableProps) => {
  const {
    entries,
    columns,
    totalCount,
    isLoading: loading,
    filters,
    onFilterChange,
  } = useTasksTable(groupName);

  return (
    <PreviewTable
      rows={entries}
      columns={columns}
      filters={filters}
      setFilters={onFilterChange}
      totalCount={totalCount}
      loading={isLoading || loading}
      type='tasks'
      displayHead={groupName === undefined}
      rowOnClick={rowOnClick}
      footerWidth={footerWidth}
    />
  );
};
